import { filterDOMProps } from '@react-aria/utils';
import type { DOMRef } from '@react-types/shared';
import type { TextProps } from '@react-types/text';
import React, { forwardRef } from 'react';
import { useDOMRef } from '../../utils';

function Text(props: TextProps, ref: DOMRef) {
  let { children, ...otherProps } = props;
  let domRef = useDOMRef(ref);

  return (
    <span
      {...filterDOMProps(otherProps)}
      className={props.UNSAFE_className}
      style={props.UNSAFE_style}
      ref={domRef}
    >
      {children}
    </span>
  );
}

let _Text = forwardRef(Text);
export { _Text as Text };
